import { Component, Injector, OnInit } from '@angular/core';
import { ApBaseModalComponent } from 'webcommon/core-ui';
import { ApMessageToken } from 'webcommon/messages';
import { FpMessagesReceivedDto } from 'webcommon/shared';
import { FacilityPortalMessageService } from '../fp-message.service';

@Component({
  providers: [{
    provide: ApMessageToken,
    useClass: FacilityPortalMessageService,
  }],
  selector: 'fp-message-reply-modal',
  templateUrl: './fp-message-reply-modal.component.html',
})
export class FPMessageReplyModalComponent extends ApBaseModalComponent<boolean> implements OnInit {
  baseId: string;
  message: FpMessagesReceivedDto;
  readOnly: boolean;
  alertWarnings: string[];

  Id: string;

  constructor(elementInjector: Injector) {
    super(elementInjector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.loading = true;
    this.setId();
    this.load();
  }

  private load() {
    this.loading = false;
  }

  private setId() {
    this.Id = `${this.baseId}-message-reply-modal`;
  }

  close(dataSaved: boolean) {
    super.closeModal(dataSaved);
  }
}
